import * as angular from "angular";
import {IController, IScope} from "angular";
import {$accountFactory} from "../../$account.factory";

export class ShipperAccountListItemCtrl implements IController {

  id: string;
  checked: boolean;
  onSelect: Function;

  constructor(private $account: $accountFactory, private $scope: IScope) {
  }

  $onInit() {
    if (this.id) {
      this.$account(this.id).$bindCtrlToId(this.$scope, this, 'account', 'id');
    }
  };

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  };
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountListItem', {
    bindings: {
      id: '<',
      checked: '<',
      onSelect: '&'
    },
    template: require('./shipper-account-list-item.html').default,
    controller: ShipperAccountListItemCtrl
  });
